import React from "react";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";

interface IBankAccountErrorPopupViewProps {
    showBox: boolean;
    onClose: () => void;
    onClick: () => void;
    data: string[];
}

export class BankAccountErrorPopupView extends FormComponent<IBankAccountErrorPopupViewProps, {}> {
    constructor(props: IBankAccountErrorPopupViewProps) {
        super(props);
    }

    public render(): JSX.Element {
        return <>{this.props.showBox ? this.renderModal() : null}</>;
    }

    private renderModal(): JSX.Element {
        return (
            <Lightbox
                show={this.props.showBox}
                title={"Error Message"}
                contentAfterTitle={null}
                onClose={() => this.props.onClose()}
                type={LightboxType.Modal}
                unclosable={false}
                noOverlay={false}
                noAutofocus={false}
                cssWrapper={"is-default-lightbox"}
            >
                {this.getModalBody()}
            </Lightbox>
        );
    }

    private getModalBody(): JSX.Element {
        const { data } = this.props;
        return (
            <>
                {data.map((error, index) => {
                    return <p key={`error-${index}`}>{error}</p>;
                })}
                <button className="btn primary" onClick={() => this.props.onClick()}>
                    Try again
                </button>
            </>
        );
    }
}
